// Generated by scripts/update-core.mjs. Do not edit.
export const CORE_VERSION = "2.6.0";
export const EJS_VERSION = "4.2.3";
